import {
  put, takeLatest, takeEvery, select, all, call,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import _ from 'lodash';
import { teamPaymentRequestMetricsSchema } from 'app/utils/redux/schemas';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';

import { sagaActions, getTeamPaymentRequestMetric } from 'app/ducks/teamPaymentRequestMetrics/actions';
import { TeamPaymentRequestMetricsActionTypes as types } from 'app/ducks/teamPaymentRequestMetrics/types';

function* getAllTeamPaymentRequestMetricsSaga(action): any {
  yield put(
    sagaActions.getAllTeamPaymentRequestMetricsPending(),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.teamPaymentRequestMetrics.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).teamPaymentRequestMetrics.list(
    paginationObject,
  );
  if (response) {
    const normalizedResponse = normalize(response, teamPaymentRequestMetricsSchema);
    yield put(
      sagaActions.getAllTeamPaymentRequestMetricsSuccess(normalizedResponse),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllTeamPaymentRequestMetricsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* getAllTeamPaymentRequestMetricsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_TEAM_PAYMENT_REQUEST_METRICS_REQUESTED, getAllTeamPaymentRequestMetricsSaga);
}

export default function* root(): any {
  yield all([
    getAllTeamPaymentRequestMetricsSagaWatcher(),
  ]);
}
